import GroupLayer from 'ol/layer/Group'
import { createLayer } from './index'

export function createGroup(config) {
  return new GroupLayer({
    title: config.title,
    fold: config.fold ?? 'open', // open | close
    layers: config.layers.map(createLayer),
    ...config.layer,
  })
}
